import { Nav, Tab } from 'react-bootstrap';
import Modal from '../../../../common/Modals/Modal/Modal';
import './PriceChartModal.scss';
import Button from '../../../../common/Button/Button';
import { CameraIcon, FullArrowIcon } from '../../../../../assets/icons/svgicons';
import Chart from '../../../../../assets/images/Chart.png';
import TradingViewGoldChart from '../../../../TradingViewChart/TradingViewGoldChart';
import TradingViewSilverChart from '../../../../TradingViewChart/TradingViewSilverChart';

const PriceChartModal = ({ show, handleClose, }) => {
    return (
        <>
            <Modal
                show={show}
                handleClose={handleClose}
                className="pricechart"
            >
                <div className='pricechart_innerSec'>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="goldenChart" className='tabContainer'>
                        <div className='tabHeader'>
                            <Nav variant="pills" className='navTabs'>
                                <Nav.Item>
                                    <Nav.Link eventKey="goldenChart">Gold Chart</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="silverChart">Silver Chart</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            {/* <div className='rightbtns'>
                                <Button
                                    className="btnSize"
                                    variant="without_bg_border"
                                >
                                    <FullArrowIcon />
                                </Button>
                                <Button
                                    className="btnSize"
                                    variant="without_bg_border"
                                >
                                    <CameraIcon />
                                </Button>
                            </div> */}
                        </div>
                        <Tab.Content className='content_inner'>
                            <Tab.Pane eventKey="goldenChart">
                                <div className='chart-img' style={{ height: "400px" }}>
                                    {/* <img src={Chart} alt='Chart' /> */}
                                    <TradingViewGoldChart />

                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="silverChart">
                                <div className='chart-img' style={{ height: "400px" }}>
                                    {/* <img src={Chart} alt='Chart' /> */}
                                    <TradingViewSilverChart />
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Modal>
        </>
    )
}

export default PriceChartModal